import { CompanyBasic } from "../app/company/company.model";
import { CompanyGroup } from "../app/company/group/gorup.model";
import { BookingModel } from "./booking.model";
import { SpaceModel } from "./space.model";
import { UserBasic } from "./user.model";

export class SpaceAssignmentModel {
  idSpace: number;
  dateFrom: Date;
  dateTo: Date;
  id?: number;
  number?: string;
  idUser?: number;
  idCompany?: number;
  idGroup?: number;
  description?: string;
  user?: UserBasic;
  company?: CompanyBasic;
  group?: CompanyGroup;
  space: SpaceModel;
  // shared?: boolean;
}
export class SpaceAssignmentWithBookingsModel {
  id?: number;
  idSpace: number;
  dateFrom: Date;
  dateTo: Date;
  number?: string;
  idUser?: number;
  idCompany?: number;
  description?: string;
  user?: UserBasic;
  company?: CompanyBasic;
  // shared?: boolean;
  bookings?: BookingModel[];
}

export class SpaceAssignmentSharedModel {
  idSpaceAssignment: number;
  dateFrom: Date;
  dateTo: Date;
}